import { apiRequest } from '@/lib/http'

// 申请api
const applyApi = {
  getTopicListByTag (data) {
    return apiRequest.post(`/api/project/apply`, data)
  }
}

export default applyApi
